<script lang="ts" setup>

interface IProps {
  name: string;
  size?: string;
}

const props = defineProps<IProps>();

const icon = defineAsyncComponent(() => import(`../../icons/${props.name}.vue`));
</script>

<template>
  <component
      :is="icon"
      :width="size"
      :height="size"
  />
</template>